import { Link } from 'react-router-dom';
import { ContactNumbers } from './ContactNumbers';
import { NewsletterForm } from './NewsletterForm';
import { Socials } from './Socials';

export function Footer(): React.JSX.Element {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand">
              <img src="/assets/inafana-logo.png" alt="" />
              <span>Inafana</span>
            </Link>
            <p>
              Software development agency. Seven-plus years building and running custom
              systems and agentic AI, internationally.
            </p>

            <ul className="footer-contact">
              <li>
                <a href="mailto:contact@inafana.com">contact@inafana.com</a>
              </li>
            </ul>
            <ContactNumbers variant="footer" />
            <Socials />
          </div>

          <div>
            <h4>Company</h4>
            <ul>
              <li>
                <Link to="/#services">What we build</Link>
              </li>
              <li>
                <Link to="/#work">Case studies</Link>
              </li>
              <li>
                <Link to="/#testimonials">Testimonials</Link>
              </li>
              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/#contact">Start a project</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Products</h4>
            <ul>
              <li>
                <Link to="/lumen">Lumen ERP</Link>
              </li>
              <li>
                <Link to="/pulse">Pulse</Link>
              </li>
              <li>
                <Link to="/mindflow">MindFlow AI</Link>
              </li>
              <li>
                <Link to="/projectflow">ProjectFlow</Link>
              </li>
              <li>
                <Link to="/kinetix">Kinetix</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4>Newsletter</h4>
            <NewsletterForm />
            <p className="newsletter-note">
              Occasional notes on agentic AI in real businesses. No spam.
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Inafana. All rights reserved.</span>
          <Link to="/privacy">Privacy policy</Link>
        </div>
      </div>
    </footer>
  );
}
